<template>
  <div class="collection-container" v-if="collectionBase">
    <Popup v-model:show="showPopup" position="bottom">
      <div v-if="isLoading" class="loading">
        <Loading></Loading>
      </div>
      <div class="sub-item-container" v-else>
        <div class="sub-item-list">
          <div
            :class="[
              'sub-item',
              item.id == currentItemId ? 'current-item' : ''
            ]"
            v-for="item in itemList"
            :key="item.id"
            @click="onChangeItem(item.id)"
          >
            <div class="sub-item-content">
              <div class="title">{{ item.title }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </Popup>

    <div class="collection">
      <div class="title-col">合集： {{ collectionBase.title }}</div>
      <div class="collection-box">
        <div class="prev" @click="prev">
          <span v-if="collectionBase.prev_item_id">
            <Icon name="arrow-left" />上一篇</span
          >
          <span v-else class="text-lite">
            <Icon name="arrow-left" />已到最前</span
          >
        </div>
        <div class="collection-menu" @click="showMenu">目录</div>

        <div class="next" @click="next">
          <span v-if="collectionBase.next_item_id"
            >下一篇<Icon name="arrow"
          /></span>
          <span v-else class="text-lite"
            >已到最后<Icon name="arrow"
          /></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popup, Icon, Loading } from "vant";
export default {
  name: "CollectionBase",
  components: {
    Popup,
    Icon,
    Loading
  },
  props: {
    currentItemId: {},
    collectionBase: {}
  },
  data() {
    return {
      itemList: [],
      showPopup: false,
      isLoading: false
    };
  },
  methods: {
    prev() {
      if (this.collectionBase.prev_item_id) {
        this.onChangeItem(this.collectionBase.prev_item_id);
      }
    },
    next() {
      if (this.collectionBase.next_item_id) {
        this.onChangeItem(this.collectionBase.next_item_id);
      }
    },

    onChangeItem(itemId) {
      this.$emit("onChange", itemId);
    },
    
    async getMenuList() {
      let params = {
        id: this.collectionBase.id
      };
      this.isLoading = true;
      await this.$store.dispatch("GetUgcItem", params).then(
        data => {
          if (data.code == 0) {
            this.itemList = data.data.collection_item_list;
          }
        },
        err => {
          console.log(err);
        }
      );
      this.isLoading = false;
    },

    showMenu() {
      this.showPopup = true;
      this.getMenuList();
    }
  }
};
</script>

<style lang="scss" scoped>
.collection {
  padding: 12px 0;
  background-color: #f5f5f5;
  .title-col {
    padding: 8px 16px;
    font-size: 16px;
  }
}

.collection-box {
  margin-top: 12px;
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prev,
.next {
  padding: 8px 12px;
  border-radius: 4px;
}

.collection-menu {
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #f0f0f0;
  cursor: pointer;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.sub-item-container {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  min-height: 50px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.sub-item-list {
  padding: 12px 8px;
}

.sub-item {
  box-sizing: border-box;
  padding: 12px;
  overflow: hidden;
  margin: 5px 8px;
  background-color: white;
  border-radius: 5px;
}

.current-item {
  border: 1px solid rgba(175, 50, 50, 0.77);
}

.sub-item-content {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.title {
  font-weight: bold;
  line-height: 2;
  overflow: hidden;
  flex: 0 0 auto;
  text-overflow: ellipsis;
  // white-space: nowrap;
}

.description {
  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*显示3行，超出的用省略号代替*/
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: grey;
  font-size: 14px;
}

.text-lite {
  color: grey;
}
</style>
